
<div class="root">
  <div class="background">
    <img class="nomidio-sad" alt="" src="/assets/image/graphic/nomidio-sad.svg">
  </div>

  <div class="foreground">
    <header>
      <img class="logo" alt="Nomidio" src="/assets/image/logo/nomidio-blue-green.svg">
    </header>
    <div class="content">
      <h2>Page not found</h2>
      <p>The page you were looking for doesn't exist. It might have been moved.</p>
      <div class="big-code">404</div>

      @if (links) {
        <div class="links">
          Try one of these pages instead:
          <ul>
            @for (link of links; track link) {
              <li><a [href]="link.href">{{link.label}}</a></li>
            }
          </ul>
        </div>
      }
    </div>
    <footer>
    </footer>
  </div>
</div>
